import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getAdminTools} from "./__graphql-types__/getAdminTools";

export const ADMIN_TOOLS_FETCH: GqlOperation<getAdminTools> = gqlOp(gql`
    query getAdminTools {
        aiGuideAdminTools {
            id
            configName
        }
    }
`);
